export default __webpack_public_path__ + "static/media/480_portfolio04-nl-web.c9095e13.png";